<template>
    <ui-dialog class="html-editor-tiptap-toolbar-code" :open.sync="isOpen" :title="$t('HtmlEditorToolbarCode.sourceCode')" :closeScrim=false>
      <template #contents>
        <textarea v-model="editedContent" style="resize:none; width: 100%; height: 420px;"></textarea>
      </template>

      <template #footer>
        <button
          type="button"
          class="ui-native --main"
          @click="onAccept"
        >{{ $t('HtmlEditorToolbarCode.accept') }}</button>
      </template>
    </ui-dialog>
  </template>

  <script>
  import { UiDialog } from '@/modules/ui/components';
  import useI18n from '@/modules/i18n/mixins/useI18n.js';

  export default {
    components: { UiDialog },
    props: {
      isOpen: {
        type: Boolean,
        default: false,
        required: false,
      },
      value: {
        type: String,
        default: '',
      },
    },
    mixins: [useI18n],
    data() {
      return {
        editedContent: '',
      };
    },
    watch: {
      value: function(newVal) {
        this.editedContent = newVal;
      },
    },
    methods: {
      onAccept() {
        this.editedContent = this.editedContent.replace(/<([^>]+)>(<iframe[^>]*>.*<\/iframe>)<\/\1>/g, '$2');

        this.$emit('content-updated', this.editedContent);
        this.$emit('close');
        this.editedContent = this.value;
      },
    },
    i18n: {
      en: {
        'HtmlEditorToolbarCode.accept': 'Accept',
        'HtmlEditorToolbarCode.sourceCode': 'Source code',

      },
      es: {
        'HtmlEditorToolbarCode.accept': 'Aceptar',
        'HtmlEditorToolbarCode.sourceCode': 'Código fuente',
      },
      de: {
        'HtmlEditorToolbarCode.accept': 'Akzeptieren',
        'HtmlEditorToolbarCode.sourceCode': 'Quellcode',
      },
    },
  }
  </script>

<style lang="scss">
.html-editor-tiptap-toolbar-code .ui-dialog-container {
  max-height: 600px !important;
  top: 10% !important;
}
</style>